/** @jsxRuntime classic */
/** @jsx jsx */
import { useState } from 'react';
import { css, jsx } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import MuiDialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Text from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useUserActions } from '../../actions/UserActions';

export default function ChangeDocumentTemplateDialog({ open, data, onClose }) {
  const { t } = useTranslation();
  const { updateUserAsync } = useUserActions();
  const [changeDefault, setChangeDefault] = useState(false);
  console.log('data is', data);

  async function onConfirm() {
    if (changeDefault) {
      await updateUserAsync({
        defaultTemplate: data.template,
      });
    }
    onClose(true);
  }

  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      css={css`
        z-index: 4000;
      `}
    >
      <DialogTitle>{t('Byt mall')}</DialogTitle>
      <DialogContent>
        <Text>
          {t('Är du säker? Detta kommer att ersätta allt nuvarande innehåll')}
        </Text>
        <FormControlLabel
          css={css`
            margin-top: 1rem;
          `}
          control={
            <Checkbox
              checked={changeDefault}
              onChange={(e) => setChangeDefault(e.target.checked)}
            />
          }
          label={t('Byt standardmall till denna mall')}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)}>{t('Avbryt')}</Button>
        <Button onClick={onConfirm}>{t('Bekräfta')}</Button>
      </DialogActions>
    </MuiDialog>
  );
}
